import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Button
} from 'semantic-ui-react'

const CardEmployeeProfileUX = (props: any) => {
    return(
      <div
        id="ModEditDiscountUX-div-0"
        style={{padding: "10px"}}>
        <Form
          id="CardEmployeeInfoManagementUX-Form-1">
          <FormGroup
            id="CardEmployeeInfoManagementUX-FormGroup-2"
            inline={true}>
            <FormField
              id="CardEmployeeProfileUX-FormField-14"
              style={{display:props.buttonBack?"":"none"}}>
              <div
                id="CardEmployeeProfileUX-div-15">
                {props.buttonBack}
              </div>
            </FormField>
            <FormField
              id="CardEmployeeInfoManagementUX-FormField-3"
              inline={true}
              style={{display: props.filteredTabMenu?.includes("EMPLOYEE_INFO")?"":"none"}}>
              <Button
                color={props.tab==="EMPLOYEE_INFO"?"blue":undefined}
                id="CardEmployeeInfoManagementUX-Button-6"
                name="EMPLOYEE_INFO"
                onClick={props.onChangeTab}
                size="small">
                Employee Information
              </Button>
            </FormField>
            <FormField
              id="CardEmployeeInfoManagementUX-FormField-5"
              inline={true}
              style={{display: props.filteredTabMenu?.includes("EMPLOYEE_DOCUMENT")?"":"none"}}>
              <Button
                color={props.tab==="EMPLOYEE_DOCUMENT"?"blue":undefined}
                disabled={!props.selectedEmployee}
                id="CardEmployeeInfoManagementUX-Button-8"
                name="EMPLOYEE_DOCUMENT"
                onClick={props.onChangeTab}
                size="small">
                Employee Document
              </Button>
            </FormField>
            <FormField
              id="CardEmployeeInfoManagementUX-FormField-4"
              inline={true}
              style={{display: props.filteredTabMenu?.includes("DS_PERMISSION")?"":"none"}}>
              <Button
                color={props.tab==="DS_PERMISSION"?"blue":undefined}
                disabled={!props.selectedEmployee}
                id="CardEmployeeInfoManagementUX-Button-7"
                name="DS_PERMISSION"
                onClick={props.onChangeTab}
                size="small">
                Division/Special permission
              </Button>
            </FormField>
            <FormField
              id="CardEmployeeProfileUX-FormField-10"
              inline={true}
              style={{display: props.filteredTabMenu?.includes("EMPLOYEE_PAYMENT")?"":"none"}}>
              <Button
                color={props.tab==="EMPLOYEE_PAYMENT"?"blue":undefined}
                disabled={!props.selectedEmployee}
                id="CardEmployeeProfileUX-Button-11"
                name="EMPLOYEE_PAYMENT"
                onClick={props.onChangeTab}
                size="small">
                Employee payment detail
              </Button>
            </FormField>
            <FormField
              id="CardEmployeeProfileUX-FormField-12"
              inline={true}
              style={{display: props.filteredTabMenu?.includes("EMPLOYEE_HISTORY")?"":"none"}}>
              <Button
                color={props.tab==="EMPLOYEE_HISTORY"?"blue":undefined}
                disabled={!props.selectedEmployee}
                id="CardEmployeeProfileUX-Button-13"
                name="EMPLOYEE_HISTORY"
                onClick={props.onChangeTab}
                size="small">
                Employee info history
              </Button>
            </FormField>
          </FormGroup>
        </Form>
        <div
          className="ui divider"
          id="CardEmployeeInfoManagementUX-div-9"
          style={{margin: "-0.5rem 0 0.75rem"}}>

        </div>
      </div>
    )
}


export default CardEmployeeProfileUX

export const screenPropsDefault = {"cannotPay":false,"cashAmountText":"14","citizenID":"31020000552","oweText":123,"patientNameAndHN":"HN: xxxxx นายทดสอบ","sumAmount":{"price":100,"reimbursable":42}}

/* Date Time : Tue Jul 08 2025 12:11:27 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "ModEditDiscountUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoManagementUX-Form-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoManagementUX-FormGroup-2"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoManagementUX-FormField-3"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.filteredTabMenu?.includes(\"EMPLOYEE_INFO\")?\"\":\"none\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoManagementUX-FormField-4"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.filteredTabMenu?.includes(\"DS_PERMISSION\")?\"\":\"none\"}"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoManagementUX-FormField-5"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.filteredTabMenu?.includes(\"EMPLOYEE_DOCUMENT\")?\"\":\"none\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "Button",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": "Employee Information"
        },
        "color": {
          "type": "code",
          "value": "props.tab===\"EMPLOYEE_INFO\"?\"blue\":undefined"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoManagementUX-Button-6"
        },
        "name": {
          "type": "value",
          "value": "EMPLOYEE_INFO"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeTab"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "Button",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "Division/Special permission"
        },
        "color": {
          "type": "code",
          "value": "props.tab===\"DS_PERMISSION\"?\"blue\":undefined"
        },
        "disabled": {
          "type": "code",
          "value": "!props.selectedEmployee"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoManagementUX-Button-7"
        },
        "name": {
          "type": "value",
          "value": "DS_PERMISSION"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeTab"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "Button",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "Employee Document"
        },
        "color": {
          "type": "code",
          "value": "props.tab===\"EMPLOYEE_DOCUMENT\"?\"blue\":undefined"
        },
        "disabled": {
          "type": "code",
          "value": "!props.selectedEmployee"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoManagementUX-Button-8"
        },
        "name": {
          "type": "value",
          "value": "EMPLOYEE_DOCUMENT"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeTab"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoManagementUX-div-9"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"-0.5rem 0 0.75rem\"}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeProfileUX-FormField-10"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.filteredTabMenu?.includes(\"EMPLOYEE_PAYMENT\")?\"\":\"none\"}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "Button",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": "Employee payment detail"
        },
        "color": {
          "type": "code",
          "value": "props.tab===\"EMPLOYEE_PAYMENT\"?\"blue\":undefined"
        },
        "disabled": {
          "type": "code",
          "value": "!props.selectedEmployee"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeProfileUX-Button-11"
        },
        "name": {
          "type": "value",
          "value": "EMPLOYEE_PAYMENT"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeTab"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeProfileUX-FormField-12"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.filteredTabMenu?.includes(\"EMPLOYEE_HISTORY\")?\"\":\"none\"}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "Button",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": "Employee info history"
        },
        "color": {
          "type": "code",
          "value": "props.tab===\"EMPLOYEE_HISTORY\"?\"blue\":undefined"
        },
        "disabled": {
          "type": "code",
          "value": "!props.selectedEmployee"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeProfileUX-Button-13"
        },
        "name": {
          "type": "value",
          "value": "EMPLOYEE_HISTORY"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeTab"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeProfileUX-FormField-14"
        },
        "style": {
          "type": "code",
          "value": "{display:props.buttonBack?\"\":\"none\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonBack"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeProfileUX-div-15"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 15,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardEmployeeProfileUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "cannotPay": false,
    "cashAmountText": "14",
    "citizenID": "31020000552",
    "oweText": 123,
    "patientNameAndHN": "HN: xxxxx นายทดสอบ",
    "sumAmount": {
      "price": 100,
      "reimbursable": 42
    }
  },
  "width": 75
}

*********************************************************************************** */
